// extracted by mini-css-extract-plugin
module.exports = {"content":"cLCxe","content-text":"jjPai","content-img":"NbZoZ"};